var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"2rem"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.go}},[_vm._v("立即咨询")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }